import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { MenuType } from './menu-type.types';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { ZopUxLayoutLibConfig } from '../config/public-api';
import { ZOP_UX_LAYOUT_LIB_CONFIG } from '../../const/zop-ux-layout.token';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _httpClient = inject(HttpClient);
    private _navigation: ReplaySubject<MenuType> = new ReplaySubject<MenuType>(
        1
    );
    private _navigationUrl: string;

    constructor(
        @Inject(ZOP_UX_LAYOUT_LIB_CONFIG) config: ZopUxLayoutLibConfig
    ) {
        // Private
        this._navigationUrl = config?.navigationUrl ?? 'api/common/navigation';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<MenuType> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<MenuType> {
        return this._httpClient.get<MenuType>(this._navigationUrl).pipe(
            tap((navigation) => {
                this._navigation.next(navigation);
            })
        );
    }
}
